
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 4a.964.964 0 00-.708.292A.964.964 0 004 5c0 .278.097.514.292.708.194.195.43.292.708.292a.964.964 0 00.708-.292A.964.964 0 006 5a.964.964 0 00-.292-.708A.964.964 0 005 4zm0 6.667a.964.964 0 00-.708.291.965.965 0 00-.292.709c0 .277.097.514.292.708.194.194.43.292.708.292a.965.965 0 00.708-.292.964.964 0 00.292-.708.965.965 0 00-.292-.709.964.964 0 00-.708-.291zM2.667 2h10.666c.19 0 .348.064.475.192a.645.645 0 01.192.475v4.666a.645.645 0 01-.192.475.645.645 0 01-.475.192H2.667a.645.645 0 01-.475-.192A.645.645 0 012 7.333V2.667c0-.19.064-.348.192-.475A.645.645 0 012.667 2zm0 6.667h10.666c.19 0 .348.064.475.191a.645.645 0 01.192.475V14a.645.645 0 01-.192.475.645.645 0 01-.475.192H2.667a.645.645 0 01-.475-.192A.645.645 0 012 14V9.333c0-.189.064-.347.192-.475a.645.645 0 01.475-.191z"}})])
          )
        }
      }
    